import React from 'react'
import Caption from 'components/Luxkit/Typography/Caption'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import LinePlaneDepartureIcon from 'components/Luxkit/Icons/line/LinePlaneDepartureIcon'

interface Props {
  className?: string;
}

function BedbankFlightPricing(props: Props) {
  const {
    className,
  } = props

  const message = <Caption as="span" variant="large" colour="neutral-one">Hotel + flight package available</Caption>

  return <CaptionTextBlock
    className={className}
    variant="large"
    desktopAlign="center"
    wrap="pre-wrap"
    startIcon={<LinePlaneDepartureIcon colour="neutral-one" />}
  >
    {message}
  </CaptionTextBlock>
}

export default BedbankFlightPricing
